// 返回背景图片
export function stdBg(val) {
    // let bgList = [
    //     "std_bg.png",
    //     "std_bg2.png",
    //     "std_bg3.png",
    //     "std_bg4.png",
    //     "std_bg5.png",
    //     "std_bg6.png",
    //     "std_bg7.png",
    //     "std_bg8.png",
    //     "std_bg9.png",
    //     "std_bg10.png",
    //     "std_bg11.png",
    //     "std_bg12.png",
    //     "std_bg13.png",
    //     "std_bg14.png",
    //     "std_bg15.png",
    //     "std_bg16.png",
    //     "std_bg17.png",
    //     "std_bg18.png",
    //     "std_bg19.png",
    // ];
    return "std_bg_" + val.toString() + ".jpg";
}


// WEBPACK FOOTER //
// ./src/assets/js/commonMethods.js